(function($) {
  if ($(".template-collection")) {
    //work only in collection page
    History.Adapter.bind(window, 'statechange', function() {
      var State = History.getState();
      if (!claue.isSidebarAjaxClick) {
        claue.sidebarParams();
        var newurl = claue.sidebarCreateUrl();
        claue.sidebarGetContent(newurl);
        claue.reActivateSidebar();
      }
      claue.isSidebarAjaxClick = false;
    });
  }

  $(document).ready(function() {
    claue.init();
    claue.wcInitSidebarFilter();
  });
  var claue = {
    claueTimeout: null,
    isSidebarAjaxClick: false,
    init: function() {
      this.initSidebar();
      this.initInfiniteScrolling();
    },
    sidebarMapTagEvents: function() {
      $('.ajaxFilter li > a').click(function(e) {
         e.preventDefault();
        var currentTags = [];
        if (Shopify.queryParams.constraint) {
          currentTags = Shopify.queryParams.constraint.split('+');
        }

        //one selection or multi selection
        if (!$(this).parent().hasClass("chosen")) {
          //remove other selection first
          var otherTag = $(this).parents('.listFilter').find("li.chosen");
          if (otherTag.length > 0) {
            var tagName = otherTag.data("filter");
            if (tagName) {
              var tagPos = currentTags.indexOf(tagName);
              if (tagPos >= 0) {
                //remove tag
                currentTags.splice(tagPos, 1);
              }
            }
          }
        }

        var tagName = $(this).parent().data("filter");
        if (tagName) {
          var tagPos = currentTags.indexOf(tagName);
          if (tagPos >= 0) {
            //tag already existed, remove tag
            currentTags.splice(tagPos, 1);
          } else {
            //tag not existed
            currentTags.push(tagName);
          }
        }
        if (currentTags.length) {
          Shopify.queryParams.constraint = currentTags.join('+');
        } else {
          delete Shopify.queryParams.constraint;
        }
        claue.sidebarAjaxClick();
      });
    },
    sidebarMapCategories: function() {
      $(".sidebar-links a").click(function(e) {
        e.preventDefault();
        if (!$(this).parents().hasClass('current-cat')) {
          delete Shopify.queryParams.q;
          claue.sidebarAjaxClick($(this).attr('href'));

          //activate selected category
          $(".sidebar-links li.current-cat").removeClass("current-cat");
           $(this).parent().addClass("current-cat");

          var par = $(this).parent();
          if (par.hasClass("dropdown") && !par.hasClass("click")) {
            $(".dropdown.click").removeClass("click");
            par.addClass("click");                      
          }
        }
      });

      $(".sidebar-links li .caret").click(function(n) {
        console.log("click there");
        var t = $(this).parent();
        if (t.hasClass("click"))
        {
          t.removeClass("click");
        }
        else
        {
          t.addClass("click");
        }              
        n.preventDefault();
      });
    },
    sidebarTeaShow: function() {
      $(".wc-col-switch a").click(function(e) {
        if (!$(this).hasClass("active")) {
          var thisPaging = $(this).attr('href');

            Shopify.queryParams.view = thisPaging;

          claue.sidebarAjaxClick();
          $(".wc-col-switch a.active").removeClass("active");
          $(this).addClass("active");
        }
        e.preventDefault();
      });
    },
    
    sidebarInitToggle: function() {
      if ($(".sidebar-tag").length > 0) {
        $(".sidebar-tag .widget-title span").click(function() {
          var $title = $(this).parents('.widget-title');
          if ($title.hasClass('click')) {
            $title.removeClass('click');
          } else {
            $title.addClass('click');
          }

          $(this).parents(".sidebar-tag").find(".widget-content").slideToggle();
        });
      }
      if ($(".sidebar-links").length > 0) {
        $(".sidebar-links .widget-title span").click(function() {
          var $title = $(this).parents('.widget-title');
          if ($title.hasClass('click')) {
            $title.removeClass('click');
          } else {
            $title.addClass('click');
          }

          $(this).parents(".sidebar-links").find(".widget-content").slideToggle();
        });
        $('.sidebar-links ul.cat-dropdown a').parents(".dropdown").removeClass("click");  
        $('.sidebar-links a.active').parents(".dropdown").addClass("click").find("ul.cat-dropdown").show();
      }
    },
    sidebarMapSorting: function(e) {
       $('#sortBy').bind('change', function() {
           Shopify.queryParams.sort_by = jQuery(this).val();
           claue.sidebarAjaxClick();
         }
       );
    },
    sidebarMapPaging: function() {
      $(".pagination-page a").click(function(e) {
        var page = $(this).attr("href").match(/page=\d+/g);
        if (page) {
          Shopify.queryParams.page = parseInt(page[0].match(/\d+/g));
          if (Shopify.queryParams.page) {
            var newurl = claue.sidebarCreateUrl();
            claue.isSidebarAjaxClick = true;
            History.pushState({
              param: Shopify.queryParams
            }, newurl, newurl);
            claue.sidebarGetContent(newurl);
            //go to top
            $('body,html').animate({
              scrollTop: 500
            }, 600);
          }
        }
        e.preventDefault();
      });
    },
    sidebarMapClearAll: function() {
      //clear all selection
      $('.refined-widgets a.clear-all').click(function(e) {
        delete Shopify.queryParams.constraint;
        delete Shopify.queryParams.q;
        claue.sidebarAjaxClick();
        e.preventDefault();
      });
    },
    sidebarMapClear: function() {
      $(".ajaxFilter").each(function() {
        var sidebarTag = $(this);
        if (sidebarTag.find(".listFilter > li.chosen").length > 0) {
          //has active tag
          sidebarTag.find(".clear").show().click(function(e) {
            console.log("im clear");
            var currentTags = [];
            if (Shopify.queryParams.constraint) {
              currentTags = Shopify.queryParams.constraint.split('+');
            }
            sidebarTag.find(".listFilter > li.chosen").each(function() {
              var selectedTag = $(this);
              var tagName = selectedTag.data("filter");
              if (tagName) {
                var tagPos = currentTags.indexOf(tagName);
                if (tagPos >= 0) {
                  //remove tag
                  currentTags.splice(tagPos, 1);
                }
              }
            });
            if (currentTags.length) {
              Shopify.queryParams.constraint = currentTags.join('+');
            } else {
              delete Shopify.queryParams.constraint;
            }
            claue.sidebarAjaxClick();
            e.preventDefault();
          });
        }
      });
    },
    sidebarMapEvents: function() {
      claue.sidebarMapTagEvents();
      claue.sidebarMapCategories();
      // claue.sidebarMapView();
      // claue.sidebarMapShow();
      claue.sidebarTeaShow();
      claue.sidebarMapSorting();
    },
    reActivateSidebar: function() {
      $(".sidebar-custom .active,.sidebar-links .active").removeClass("active");
      $(".listFilter > li.chosen").removeClass("chosen");
      $(".sidebar-tag input:checked").attr("checked", false);

      //category
      var cat = location.pathname.match(/\/collections\/(.*)(\?)?/);
      if (cat && cat[1]) {
        $(".sidebar-links a[href='" + cat[0] + "']").addClass("active");
      }

      //view mode and show filter
      if (Shopify.queryParams.view) {
        $(".view-mode .active").removeClass("active");
        var view = Shopify.queryParams.view;
        if (view.indexOf("list") >= 0) {
          $(".view-mode .list").addClass("active");
          //paging
          view = view.replace("list", "");
        } else {
          $(".view-mode .grid").addClass("active");
        }
        $(".filter-show > button span.number").text(view);
        $(".filter-show li.active").removeClass("active");
        $(".filter-show a[href='" + view + "']").parent().addClass("active");
      }
      claue.initSortby();
    },
    initSortby: function() {
      //sort by filter
      if (Shopify.queryParams.sort_by) {
        var sortby = Shopify.queryParams.sort_by;
      }
    },
    sidebarMapData: function(data) {
      var currentList = $(".yit-wcan-container .products");
      var productList = $(data).find(".yit-wcan-container .products");
      if (productList.length > 0 && productList.hasClass("products-grid")) {
        if (window.product_image_resize) {
          productList.find('img').fakecrop({
            fill: window.images_size.is_crop,
            widthSelector: ".tea_col .product-inner .product-image",
            ratioWrapper: window.images_size
          });
        }
      }
      currentList.replaceWith(productList);
      //convert currency
      $('.currency .active').trigger('click');
      if (claue.checkNeedToConvertCurrency()) {
//           Currency.convertAll(window.shop_currency, jQuery('jQuery('.currency .active').trigger('click');, '.col-main span.money', 'money_format');
//          jQuery('.currency .active').trigger('click');
        jQuery('.currency .active').trigger('click');
      }

      //replace paging
      if ($(".padding").length > 0) {
          $(".padding").replaceWith($(data).find(".padding"));
      } else {
        
          $(".jas-filter-wrap").append($(data).find(".padding"));
          
      }

      //replace title & description
       $(".page-head").replaceWith($(data).find(".page-head"));
      //replace refined
      $(".refined-widgets").replaceWith($(data).find(".refined-widgets"));

      //replace tags
      $(".sidebar-block").replaceWith($(data).find(".sidebar-block"));
      $(".sidebar-product").replaceWith($(data).find(".sidebar-product"));
      //product review
      if ($(".spr-badge").length > 0) {
        return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
      }
      $('.close-filter').on( 'click', function(ev) {
         $( '.jas-filter-wrap' ).removeClass( 'opened' );
         ev.preventDefault();
      });
    },
    sidebarCreateUrl: function(baseLink) {
      var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, '+');
      if (baseLink) {
        //location.href = baseLink + "?" + newQuery;
        if (newQuery != "")
          return baseLink + "?" + newQuery;
        else
          return baseLink;
      }
      return location.pathname + "?" + newQuery;
    },
    sidebarAjaxClick: function(baseLink) {
      delete Shopify.queryParams.page;
      var newurl = claue.sidebarCreateUrl(baseLink);
      claue.isSidebarAjaxClick = true;
      History.pushState({
        param: Shopify.queryParams
      }, newurl, newurl);
      claue.sidebarGetContent(newurl);
    },
    sidebarGetContent: function(newurl) {
      $.ajax({
        type: 'get',
        url: newurl,
        beforeSend: function() {
          claue.showLoading();
          $('body.template-collection,html').animate({
           scrollTop: 0
         }, 800);
        },
        success: function(data) {
          claue.sidebarMapData(data);
          claue.sidebarMapPaging();
          claue.initMasonry();
          claue.sidebarMapTagEvents();
          claue.sidebarInitToggle();
          claue.sidebarMapClear();
          claue.sidebarMapClearAll();
          claue.hideLoading();
          claue.initInfiniteScrolling();
          $(window).trigger("initWishlistNoCustomer");
//           claue.initScrollbar();
        },
        error: function(xhr, text) {
          claue.hideLoading();
          $('.loading-modal').hide();
          $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
          claue.showModal('.ajax-error-modal');
        }
      });
    },
    sidebarParams: function() {
      Shopify.queryParams = {};
      //get after ?...=> Object {q: "Acme"} 
      if (location.search.length) {
        for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }
    },
    
    initSidebar: function() {
      //if category page then init sidebar
      if ($(".template-collection").length > 0) {
        claue.sidebarParams();
        claue.initSortby();
        claue.sidebarMapEvents();
        claue.sidebarMapPaging();
        claue.sidebarInitToggle();
        claue.sidebarMapClear();
        claue.sidebarMapClearAll();
      }
    },
    initInfiniteScrolling: function() {
      if ($('.infinite-scrolling').length > 0) {
        $('.infinite-scrolling a').click(function(e) {
          e.preventDefault();
          if (!$(this).hasClass('disabled')) {
            claue.doInfiniteScrolling();
          }
        });
      }
    },
    doInfiniteScrolling: function() {
      var currentList = $('.yit-wcan-container .products'),
           MoreText = "Load more products";
      if (currentList) {
        var showMoreButton = $('.infinite-scrolling a').first();
        $.ajax({
          type: 'GET',
          url: showMoreButton.attr("href"),
          beforeSend: function() {
           showMoreButton.html( '<i class="fa fa-circle-o-notch fa-spin"></i>' );

          },
          success: function(data) {
//             claue.hideLoading();
            var products = $(data).find(".yit-wcan-container .products");
            if (products.length) {
              // currentList.append(products.children());
              products.imagesLoaded( function() {
                  var elem = $( products.children() );
                   currentList.isotope({
                    itemSelector : '.tea_col'
                     // columnWidth : '.grid-sizer'
                  });
                 currentList.append( elem ).isotope( 'appended', elem ).isotope('layout');
              });
              //get link of Show more
              if ($(data).find('.infinite-scrolling').length > 0) {
                showMoreButton.attr('href', $(data).find('.infinite-scrolling a').attr('href'));
              } else {
                //no more products
                showMoreButton.hide();
                showMoreButton.next().show();
              }

              //currency
              $('.currency .active').trigger('click');
              
              //product review
              if ($(".spr-badge").length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              }
            }
          },
          error: function(xhr, text) {
            $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
          },
          dataType: "html"
        }).done(function() {
         showMoreButton.text(MoreText);
        });
      }
    },
    showLoading: function() {
      $('.yit-wcan-container').addClass('yith-wcan-loading');
    },
    hideLoading: function() {
      $('.yit-wcan-container').removeClass('yith-wcan-loading');
    },
   initMasonry: function() {
      var el = $( '.jas-masonry' );
      el.each( function( i, val ) {
         var _option = $( this ).data( 'masonry' );
         if ( _option !== undefined ) {
            var _selector = _option.selector,
               _width    = _option.columnWidth,
               _layout   = _option.layoutMode;

            $( this ).imagesLoaded( function() {
               $( val ).isotope( {
                  layoutMode : _layout,
                  itemSelector: _selector,
                  percentPosition: true,
                  masonry: {
                     columnWidth: _width
                  }
               } );
            });
         }
      });
   },
   initWishlistNoCustomer: function() {
       updateWishlistButtons();
       initWishlistButtons();
     },
   wcInitSidebarFilter: function() {
      $( 'body' ).on( 'click', '.filter-trigger', function(e) {
         $( '.jas-filter-wrap' ).toggleClass( 'opened' );
         $( '.close-filter' ).on( 'click', function() {
            $( '.jas-filter-wrap' ).removeClass( 'opened' );
         });
         e.preventDefault();
      });
   },
    checkNeedToConvertCurrency: function() {
      return window.show_multiple_currencies && Currency.currentCurrency != shopCurrency;
    }
  }
  })(jQuery);